import { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function Settings() {
  const [settings, setSettings] = useState({});
  const [integrations, setIntegrations] = useState({});
  const [loading, setLoading] = useState(true);
  const [apiKeys, setApiKeys] = useState({
    instantly: '',
    claude: '',
    newsapi: ''
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const [settingsRes, integrationsRes] = await Promise.all([
        axios.get(`${API_BASE}/settings`),
        axios.get(`${API_BASE}/settings/integrations`)
      ]);
      setSettings(settingsRes.data.settings);
      setIntegrations(integrationsRes.data.integrations);
    } catch (error) {
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateApiKey = async (service) => {
    try {
      await axios.put(`${API_BASE}/settings/integrations/${service}`, {
        apiKey: apiKeys[service]
      });
      alert(`${service} API key updated`);
      setApiKeys({ ...apiKeys, [service]: '' });
      fetchSettings();
    } catch (error) {
      console.error(`Error updating ${service} API key:`, error);
      alert(`Error updating ${service} API key`);
    }
  };

  if (loading) {
    return <div className="text-center p-8">Loading settings...</div>;
  }

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Settings</h1>

      {/* API Keys */}
      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">API Keys</h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Instantly.ai API Key
            </label>
            <div className="flex gap-2">
              <input
                type="password"
                value={apiKeys.instantly}
                onChange={(e) => setApiKeys({ ...apiKeys, instantly: e.target.value })}
                placeholder={integrations.instantly?.configured ? '••••••••' : 'Enter API key'}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
              />
              <button
                onClick={() => handleUpdateApiKey('instantly')}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                {integrations.instantly?.configured ? 'Update' : 'Save'}
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Status: {integrations.instantly?.configured ? '✓ Configured' : '✗ Not configured'}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Claude API Key
            </label>
            <div className="flex gap-2">
              <input
                type="password"
                value={apiKeys.claude}
                onChange={(e) => setApiKeys({ ...apiKeys, claude: e.target.value })}
                placeholder={integrations.claude?.configured ? '••••••••' : 'Enter API key'}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
              />
              <button
                onClick={() => handleUpdateApiKey('claude')}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                {integrations.claude?.configured ? 'Update' : 'Save'}
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Status: {integrations.claude?.configured ? '✓ Configured' : '✗ Not configured'}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              NewsAPI Key (Optional)
            </label>
            <div className="flex gap-2">
              <input
                type="password"
                value={apiKeys.newsapi}
                onChange={(e) => setApiKeys({ ...apiKeys, newsapi: e.target.value })}
                placeholder={integrations.newsapi?.configured ? '••••••••' : 'Enter API key'}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
              />
              <button
                onClick={() => handleUpdateApiKey('newsapi')}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                {integrations.newsapi?.configured ? 'Update' : 'Save'}
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Status: {integrations.newsapi?.configured ? '✓ Configured' : '✗ Not configured'}
            </p>
          </div>
        </div>
      </div>

      {/* System Information */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold mb-4">System Information</h2>
        <div className="space-y-2 text-sm">
          <p><strong>ZoomInfo CSV Directory:</strong> {settings.zoominfo_csv_dir || '/root/zoominfo-scraper/output'}</p>
          <p><strong>Campaign Default Daily Limit:</strong> {settings.campaign_default_daily_limit || '50'}</p>
          <p><strong>MQL Price:</strong> ${settings.mql_price || '100.00'}</p>
          <p><strong>Max MQL Resales:</strong> {settings.max_mql_resales || '5'}</p>
        </div>
      </div>
    </div>
  );
}
